import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=da5e39de"
import script from "./AppForm.vue?vue&type=script&lang=ts"
export * from "./AppForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports